module.exports = __webpack_public_path__ + "img/class8.787f6f89.png";